<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">
            {{'TITLE.TITLE_START_STOP_SHIFT' | translate}} ({{Model.ShiftName}})
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row no-gutters mb-2">
            <!--<div class="w-auto input-group">
        <div class="input-group-prepend">
            <button class="input-group-text pointer" title="{{'TITLE.TITLE_FILTERS' | translate
    }}" [ngClass]="FilterModel.HasFilters ? 'highlight_Color':''" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseFilter" (click)="isCollapsed = !isCollapsed">
                <i class="fas fa-filter"></i>
            </button>
        </div>
        <input class="form-control" type="search" placeholder="{{'PH.PH_SEARCH' | translate}}" aria-label="Search" name="Keyword" [(ngModel)]="FilterModel.Keyword" (keyup)="LoadFilterStaffData()">
        <div class="input-group-append">
            <button class="btn btn-secondary" type="button" title="{{'TITLE.TITLE_CLEAR_FILTER' | translate}}" (click)="onClearFilter()"><i class="fas fa-eraser"></i></button>
        </div>
    </div>-->
            <div class="col-auto d-flex align-items-center header_section">
                <div class="searchFilterResult">
                    <input class="form-control" type="search" placeholder="{{'PH.PH_SEARCH' | translate}}" aria-label="Search" name="Keyword" [(ngModel)]="FilterModel.Keyword" (keyup)="LoadFilterStaffData()">
                </div>
            </div>

            <div class="col-auto d-flex header_section align-items-center px-4" [ngClass]="HasFilter ? 'rounded backHightlight ml-2':''">
                <div class="pointer" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseFilter" (click)="isCollapsed = !isCollapsed" title="{{'TITLE.TITLE_FILTERS' | translate}}"><i class="fas fa-filter"></i></div>
                <div class="ml-4 pointer" (click)="onClearFilter()" *ngIf="HasFilter"><i class="fas fa-times fa-lg mr-2"></i>{{'TITLE.TITLE_CLEAR_FILTER' | translate}}</div>
            </div>
        </div>

        <div class="row no-gutters mb-2 form-inline" id="collapseFilter" [ngbCollapse]="isCollapsed">
            <div class="mr-2">
                <select class="custom-select" id="StaffMapped" [(ngModel)]="FilterModel.StaffMapped" name="StaffMapped" (change)="LoadFilterStaffData()">
                    <option value="" translate>ENTITIES.ENTITIES_MAPPING_STATUS</option>
                    <option value="and length(Sections) > 0" translate>ENTITIES.ENTITIES_MAPPED_STAFF</option>
                    <option value="and length(Sections) = 0" translate>ENTITIES.ENTITIES_UNMAPPED_STAFF</option>
                </select>
            </div>
            <div class="mr-2">
                <select class="custom-select" id="Skills" [(ngModel)]="FilterModel.SkillId" name="Skills" (change)="LoadFilterStaffData()" >
                    <option value="0" translate>CMB_DEF.CMB_DEF_SKILL</option>
                    <option *ngFor="let row of shiftSetUp.skillList" [ngValue]="row.Id">{{row.Name}}</option>
                </select>
            </div>
            <div class="mr-2">
                <select class="custom-select" id="ServiceStatus" [(ngModel)]="FilterModel.ServiceStatus" name="ServiceStatus" (change)="LoadFilterStaffData()">
                    <option value="" translate>ENTITIES.ENTITIES_TYPE</option>
                    <option value="and IsServiceStaff = true" translate>ENTITIES.ENTITIES_SERVICE</option>
                    <option value="and IsServiceStaff = false" translate>ENTITIES.ENTITIES_NON_SERVICE</option>
                </select>
            </div>
            <div class="mr-2">
                <select class="custom-select" id="LoginStatus" [(ngModel)]="FilterModel.LoginStatus" name="LoginStatus" (change)="LoadFilterStaffData()">
                    <option value="" translate>ENTITIES.ENTITIES_STATUS</option>
                    <option value="and IsLoggedIn = true" translate>ENTITIES.ENTITIES_LOGGED_IN</option>
                    <option value="and IsLoggedIn = false" translate>ENTITIES.ENTITIES_LOGGED_OUT</option>
                </select>
            </div>
        </div>
        <div class="grdTable">
            <div class="row no-gutters grdTableHeader">
                <div class="col-1 grdHead text-center" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_Login_Logout)">
                    <input class="" type="checkbox" id="AllStaff" (change)="MultipleStaffInOut($event)" [checked]="AllStaffAdded">
                </div>
                <div class="col-2 grdHead"></div>
                <div class="col-6 grdHead"><span translate>LBL.STAFF</span></div>
                <div class="col-3 grdHead text-center">
                    <span translate>LBL.OPENCALLS</span>
                    <div class="row no-gutters">
                        <div class="col-6 font-weight-normal"><span translate>LBL.ALL</span></div>
                        <div class="col-6 font-weight-normal"><span translate>LBL.CURRENT</span></div>
                    </div>
                </div>
            </div>
            <div class="grdBodyScroll-Virtual" #scrollingBlock>
                <virtual-scroller #scroll [items]="StaffList" style="height:100%" [parentScroll]="scrollingBlock.nativeElement">
                    <div *ngFor="let row of scroll.viewPortItems" class="row no-gutters grdRow">
                        <div class="col-1 grdCol text-center" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_Login_Logout)">
                            <input type="checkbox" aria-label="Checkbox for following text input" (change)="AddStaffToMultipleLogin(row, $event)" [checked]="row.AddedToMultipleLoginLst">
                        </div>
                        <div class="col-2 grdCol text-center">
                            <div class="d-inline p-0 mr-1" [ngClass]="row.IsLoggedIn ? 'LoggedInStatus' : 'LoggedOutStatus'" title="{{row.IsLoggedIn ? ('TITLE.TITLE_LOGGED_IN' | translate) : ('TITLE.TITLE_LOGGED_OUT' | translate)}}"><i class="mr-1" [class]="shiftSetUp.GetStaffStatusIcon(row)"></i></div>
                            <button class="btn btn-default bg-white p-0" [ngClass]="row.HasDevices ? 'HasDeviceIcon_Color' : 'HasNoDeviceIcon_Color'" title="{{'TITLE.TITLE_ADD_EDIT_DEVICES' | translate}}" [disabled]="!CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_EditDeviceType)" (click)="deviceDetail.Open(row.StaffId, Model)"><i class="fas fa-mobile fa-fw mx-1"></i></button>
                        </div>
                        <div class="col-6 grdCol">
                            <div class="row col ellipsis">{{row.Description}}</div>
                            <div class="row col small text-muted" *ngIf="row.Skills.length > 0"><span title="{{'TITLE.TITLE_ADDED_SKILLS' | translate}}">{{row.SkillName}}</span></div>
                        </div>
                        <div class="col-3 grdCol text-center">
                            <div class="row no-gutters">
                                <div class="col-6">{{row.AllOpenCalls}}</div>
                                <div class="col-6">{{row.OpenCalls}}</div>
                            </div>
                        </div>
                    </div>
                </virtual-scroller>

            </div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <button type="button" class="btn btn-info mr-3" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_Login_Logout)" (click)="shiftStaffInOut.Open(MultipleLoginStaffList, Model.PropertyId, true)" [disabled]="!(MultipleLoginStaffList.length > 0)" translate>BTN.BTN_START_SHIFT</button>
            <button type="button" class="btn btn-secondary" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, Model.DeptId, _AuthActionCodes.ServiceStaff_Login_Logout)" (click)="shiftStaffInOut.Open(MultipleLoginStaffList, Model.PropertyId, false)" [disabled]="!(MultipleLoginStaffList.length > 0)" translate>BTN.BTN_END_SHIFT</button>
        </div>
        <!-- <button type="button" class="btn btn-primary" (click)="DisableModalOpenEvent = false;ModalRef.close()" translate>BTN.BTN_OK</button>
         <!--<button type="button" class="btn" (click)="d('dismiss')"><span translate>TWTSS.BTN_CANCEL</span></button>-->
    </div>

</ng-template>

<DeviceDetail #deviceDetail [AllDeviceData]="shiftSetUp.ShiftResponseModel.ListStaffDevices" (DeviceUpdated)="UpdateDeviceData($event)"></DeviceDetail>

<ShiftStaffInOut #shiftStaffInOut [SectionSkillStaffData]="shiftSetUp.SectionSkillStaffData" [StaffList]="StaffList" (StaffUpdated)="UpdateStaffData($event)"></ShiftStaffInOut>
